class CookieConsentAjax {
  constructor(nonce, ajaxurl) {
    this.nonce = nonce;
    this.ajaxurl = ajaxurl;
  }

  logConsent(actionType, data) {
    const body = new URLSearchParams({
      action: "mad_log_consent_action",
      action_type: actionType,
      consent_data: JSON.stringify(data),
      security: this.nonce,
    });

    fetch(this.ajaxurl, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response || !response.success) {
          console.error("Server logging failed:", response && response.data);
        }
      })
      .catch((error) => {
        console.error("Error logging to server:", error);
      });
  }
}

module.exports = CookieConsentAjax;
